import React, { useEffect, useState } from 'react'
import sendAuthRequest from './api/login'
import { useAuth } from "./api/authStore"
import landingLogo from './img/landing-logo.png'

const Login = (props) => {
    const { user, getAccessTokenSilently, setToken, logout } = useAuth()

    const [showPassword, setShowPassword] = React.useState(false)
    const [isError, showError] = React.useState(false)
    const [errorText, setErrorText] = useState("")

    const [email, setEmail] =  useState("")
    const [passwd, setPassword] =  useState("")

    const handleChangeLogin = (e) => {
      setEmail(e.target.value)
    }
    
    const handleChangePasswd = (e) => {
      setPassword(e.target.value)
    }

    const handleClickShowPassword = () => setShowPassword((show) => !show)

    const handleSingInButton = async() => {
      try {
          const result = await sendAuthRequest(email, passwd)
          setToken(result)
          window.location.href = '/proxies'
      } catch (e) {
          if (e === 'userNotFound') {
              setErrorText("Incorrect username or password.")
          } else {
              setErrorText("Error occurs, try again later")
          }
          showError(true)
      }
  }

    return (
        <div style={{ 
            height: '100vh', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            background: 'var(--gradient-hero)',
            position: 'relative'
        }}>
            {/* Декоративный фон */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'radial-gradient(circle at 30% 20%, rgba(255, 107, 53, 0.1) 0%, transparent 50%)',
                pointerEvents: 'none'
            }} />
            
            <div className="form-card" style={{ width: '400px', minWidth: '400px' }}>
                {/* Логотип слева, заголовок по центру */}
                <div className="mobile-auth-header" style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    marginBottom: 'var(--spacing-xl)',
                    paddingBottom: 'var(--spacing-lg)',
                    borderBottom: '1px solid var(--light-gray)'
                }}>
                    <img 
                        src={landingLogo} 
                        alt="XSocks Logo" 
                        style={{
                            width: '60px',
                            height: '60px',
                            objectFit: 'contain',
                            filter: 'drop-shadow(0 4px 12px rgba(255, 107, 53, 0.3))',
                            position: 'absolute',
                            left: 'var(--spacing-md)'
                        }} 
                    />
                    <h2 style={{ margin: 0 }}>Sign In</h2>
                </div>
                
                <div className="form-group">
                    <label className="form-label">Email</label>
                    <input
                        type="email"
                        className="form-input"
                        placeholder="yours@example.com"
                        value={email}
                        onChange={handleChangeLogin}
                    />
                </div>
                
                <div className="form-group">
                    <label className="form-label">Password</label>
                    <div className="form-input-with-icon">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            className="form-input"
                            placeholder="your password"
                            value={passwd}
                            onChange={handleChangePasswd}
                        />
                        <button
                            type="button"
                            className="password-toggle"
                            onClick={handleClickShowPassword}
                        >
                            {showPassword ? '👁️' : '🙈'}
                        </button>
                    </div>
                </div>
                
                <div className="form-error" style={{ minHeight: '20px' }}>
                    {isError && (
                        <span>⚠️ {errorText}</span>
                    )}
                </div>
                
                <button 
                    className="btn btn-primary btn-large" 
                    onClick={handleSingInButton}
                    style={{ width: '100%', marginBottom: '24px' }}
                >
                    Sign In
                </button>
                
                <div className="form-link">
                    <p style={{ color: 'var(--text-muted)', margin: '0 0 8px 0' }}>
                        Don't have an account?
                    </p>
                    <a href="/signup">Sign Up!</a>
                </div>
                
                <div className="support-info" style={{ 
                    marginTop: '32px', 
                    paddingTop: '24px', 
                    borderTop: '1px solid var(--light-gray)',
                    fontSize: 'var(--text-sm)',
                    color: 'var(--text-muted)'
                }}>
                    <p style={{ margin: '0 0 8px 0' }}>
                        Support email: <a href={`mailto:${process.env.REACT_APP_EMAIL}`}>{process.env.REACT_APP_EMAIL}</a>
                    </p>
                    <p style={{ margin: '0' }}>
                        Support telegram: <a href={`tg://resolve?domain=${process.env.REACT_APP_TG}`}>{process.env.REACT_APP_TG}</a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Login